export default {
	title: 'adc_automation',
	components: [{ title: 'adc_automation', component: 'adc_automation' }],
};
